import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import DailyMonitoringFiltersContextProvider from '../context/DailyMonitoringFiltersContext'
import DailyMonitoringDetailsFiltersContextProvider from '../context/DailyMonitoringDetailsFiltersContext'
import { AuthContext } from '../context/AuthContext'

import DailyMonitoringDetails from '../pages/DailyMonitoring/DailyMonitoringDetails'
import DailyMonitoringCancelled from '../pages/DailyMonitoring/DailyMonitoringCancelled'
import DailyMonitoringResume from '../pages/DailyMonitoring/DailyMonitoringResume'
import DailyMonitoringMultipleShoppingCart from '../pages/DailyMonitoring/DailyMonitoringMultipleShoppingCart'

export default function DailyMonitoringRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <DailyMonitoringFiltersContextProvider>
      <DailyMonitoringDetailsFiltersContextProvider>
        <Switch>
          <PrivateRoutes path="/monitoramento-diario/detalhe-principal" component={DailyMonitoringDetails} auth={auth} />
          <PrivateRoutes path="/monitoramento-diario/detalhe-cancelados" component={DailyMonitoringCancelled} auth={auth} />
          <PrivateRoutes path="/monitoramento-diario/detalhe-resumo" component={DailyMonitoringResume} auth={auth} />
          <PrivateRoutes path="/monitoramento-diario/cesta-simultanea" component={DailyMonitoringMultipleShoppingCart} auth={auth} />
        </Switch>
      </DailyMonitoringDetailsFiltersContextProvider>
    </DailyMonitoringFiltersContextProvider>
  )
}
